// Real geographic coverage map data — coordinates in WGS84 (lat, lon)
export const CITIES_GEO = [
  { name: "Katowice", lat: 50.2649, lon: 19.0238, primary: true },
  { name: "Mysłowice", lat: 50.2074, lon: 19.1322 },
  { name: "Sosnowiec", lat: 50.2862, lon: 19.1041 },
  { name: "Dąbrowa Górnicza", lat: 50.3242, lon: 19.1947 },
  { name: "Siemianowice Śląskie", lat: 50.3066, lon: 19.0207 },
  { name: "Wojkowice", lat: 50.3719, lon: 19.0517 },
  { name: "Psary", lat: 50.4036, lon: 19.1308 },
  { name: "Sarnów", lat: 50.3650, lon: 19.1797 },
  { name: "Będzin", lat: 50.3275, lon: 19.1239 },
  { name: "Czeladź", lat: 50.3236, lon: 19.0769 },
  { name: "Zabrze", lat: 50.3249, lon: 18.7857 },
  { name: "Chorzów", lat: 50.2974, lon: 18.9540 },
  { name: "Bytom", lat: 50.3489, lon: 18.9320 },
  { name: "Świętochłowice", lat: 50.2945, lon: 18.9165 },
  { name: "Gliwice", lat: 50.2945, lon: 18.6714 },
  { name: "Tychy", lat: 50.1346, lon: 18.9871 },
  { name: "Bieruń", lat: 50.0867, lon: 19.0934 },
  { name: "Pyskowice", lat: 50.3997, lon: 18.6298 },
  { name: "Nieborowice", lat: 50.2275, lon: 18.5594 },
  { name: "Orzesze", lat: 50.1531, lon: 18.7869 },
  { name: "Mikołów", lat: 50.1718, lon: 18.9019 },
  { name: "Łaziska Górne", lat: 50.1499, lon: 18.8474 },
  { name: "Łaziska Średnie", lat: 50.1500, lon: 18.8400 },
  { name: "Gostyń", lat: 50.1206, lon: 18.8333 },
  { name: "Imielin", lat: 50.1378, lon: 19.1894 },
  { name: "Jaworzno", lat: 50.2014, lon: 19.2839 },
  { name: "Wyry", lat: 50.1492, lon: 18.9119 },
  { name: "Ruda Śląska", lat: 50.2589, lon: 18.8556 },
];
